var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUserMultiple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.75C7.20507 3.75 5.75 5.20507 5.75 7C5.75 8.79493 7.20507 10.25 9 10.25C10.7949 10.25 12.25 8.79492 12.25 7C12.25 5.20508 10.7949 3.75 9 3.75ZM4.25 7C4.25 4.37665 6.37665 2.25 9 2.25C11.6233 2.25 13.75 4.37664 13.75 7C13.75 9.62336 11.6233 11.75 9 11.75C6.37665 11.75 4.25 9.62335 4.25 7Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 3C14.25 2.58579 14.5858 2.25 15 2.25C17.6233 2.25 19.75 4.37664 19.75 7C19.75 9.62336 17.6233 11.75 15 11.75C14.5858 11.75 14.25 11.4142 14.25 11C14.25 10.5858 14.5858 10.25 15 10.25C16.7949 10.25 18.25 8.79492 18.25 7C18.25 5.20508 16.7949 3.75 15 3.75C14.5858 3.75 14.25 3.41421 14.25 3Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 19C1.25 15.8244 3.82436 13.25 7 13.25H11C14.1756 13.25 16.75 15.8244 16.75 19V21C16.75 21.4142 16.4142 21.75 16 21.75H2C1.58579 21.75 1.25 21.4142 1.25 21V19ZM7 14.75C4.6528 14.75 2.75 16.6528 2.75 19V20.25H15.25V19C15.25 16.6528 13.3472 14.75 11 14.75H7Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 14C16.25 13.5858 16.5858 13.25 17 13.25C20.1756 13.25 22.75 15.8244 22.75 19V21C22.75 21.4142 22.4142 21.75 22 21.75H19C18.5858 21.75 18.25 21.4142 18.25 21C18.25 20.5858 18.5858 20.25 19 20.25H21.25V19C21.25 16.6528 19.3472 14.75 17 14.75C16.5858 14.75 16.25 14.4142 16.25 14Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserMultiple);
export default __webpack_public_path__ + "static/media/ic-user-multiple.8359bae1a696d53e8a4c46d927a40da9.svg";
export { ForwardRef as ReactComponent };